// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* select task */
.aims-select-task-heading-wrap {
    margin: 24px 0;
}

.aims-select-task-heading {
    color: var(--Text-Default, var(--grayscale-860, #242424));
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
}

.aims-select-task-wrapper {
    margin-bottom: 24px;
}

.aims-select-col {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
}

.aims-select-task-btn.aims-btn-reset {
    margin-bottom: 16px;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    cursor: pointer;
    width: 100%;
}

.txt-only-card {
    display: flex;
    flex-basis: 100%;
    width: 100%;
    align-items: stretch;
    justify-content: stretch;
}

.aims-select-card-outer {
    width: 100%;
}

.aims-select-card-outer:hover {
    outline: 1px solid #1773b0;
    outline-offset: -1px;
}

.aims-select-task-card {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 10px;
}

.aims-select-task-card--txt-only {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
}

.aims-select-img-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.aims-select-task-btn:hover img {
    filter: brightness(.85);
}

@media only screen and (max-width: 1024px) {
    .aims-select-task-card:not(.aims-select-task-card--txt-only) {
        flex-direction: column;
        justify-content: flex-start;
        gap: 10px;
    }

    .aims-select-img-wrap {
        display: none;
        width: 40px
    }
}

@media only screen and (max-width: 768px) {
    .aims-select-secondary-txt-wrap {
        display: none;
    }
}

.aims-select-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    margin-left: 4px;
}

.aims-select-primary-txt {
    color: #1773b0;
}

.aims-select-task-btn:hover .aims-select-primary-txt {
    color: var(--color-interactive-primary-hover);
    text-decoration: underline;
}

.aims-select-secondary-txt {
    color: #666666;
}

/* Ideas / New */
.aims-ideas-col {
    padding-right: 30px;
    border-right: 1px solid #E2E2E2;
}

.aims-new-col {
    padding-left: 12px;
}

.aims-ideas-new-wrap {
    margin-bottom: 20px;
    margin-left: 16px;
    margin-right: 16px;
}

.aims-ideas-heading-inner {
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    /* 128.571% */
    letter-spacing: 0.1px;
}

.aims-new-ideas-heading-more {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
    margin-bottom: 10px;
}

@media only screen and (max-width: 500px) {
    .aims-new-ideas-heading-more {
        margin-bottom: 0;
    }
}

.aims-ideas-li {
    margin-bottom: 10px;
    font-size: 14px;
}

.aims-new-ul {
    padding-left: 20px;
    margin-top: 10px;
}

.aims-new-ul li {
    list-style: disc;
    margin-bottom: 10px;
    font-size: 14px;
}

.aims-select-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    margin-left: 4px;
}

.aims-select-primary-txt {
    color: #1773b0;
}

.aims-select-task-btn:hover .aims-select-primary-txt {
    color: var(--color-interactive-primary-hover);
    text-decoration: underline;
}

.aims-select-secondary-txt {
    color: #666666;
}

@media only screen and (max-width: 768px) {
    .aims-ideas-col {
        padding-right: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #E2E2E2;
        border-right: none;
    }

    .aims-new-col {
        padding-left: 0;
        padding-top: 20px;
        padding-bottom: 20px;
    }
}

@media only screen and (max-width: 500px) {
    .aims-ideas-col {
        padding-bottom: 0px;
    }

    .aims-new-col {
        padding-top: 0px;
    }

    .aims-new-ideas-heading-more {
        justify-content: flex-start;
        gap: 8px;
        font-size: 14px;
    }

    .ideas-new-list-wrap {
        display: none;
    }

    .aims-ideas-col {
        border-bottom: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/style/tasks-ideas-news.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI,yDAAyD;IACzD,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;QACpB,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/* select task */\n.aims-select-task-heading-wrap {\n    margin: 24px 0;\n}\n\n.aims-select-task-heading {\n    color: var(--Text-Default, var(--grayscale-860, #242424));\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 26px;\n}\n\n.aims-select-task-wrapper {\n    margin-bottom: 24px;\n}\n\n.aims-select-col {\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n}\n\n.aims-select-task-btn.aims-btn-reset {\n    margin-bottom: 16px;\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n    cursor: pointer;\n    width: 100%;\n}\n\n.txt-only-card {\n    display: flex;\n    flex-basis: 100%;\n    width: 100%;\n    align-items: stretch;\n    justify-content: stretch;\n}\n\n.aims-select-card-outer {\n    width: 100%;\n}\n\n.aims-select-card-outer:hover {\n    outline: 1px solid #1773b0;\n    outline-offset: -1px;\n}\n\n.aims-select-task-card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    gap: 10px;\n}\n\n.aims-select-task-card--txt-only {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    text-align: center;\n}\n\n.aims-select-img-wrap {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.aims-select-task-btn:hover img {\n    filter: brightness(.85);\n}\n\n@media only screen and (max-width: 1024px) {\n    .aims-select-task-card:not(.aims-select-task-card--txt-only) {\n        flex-direction: column;\n        justify-content: flex-start;\n        gap: 10px;\n    }\n\n    .aims-select-img-wrap {\n        display: none;\n        width: 40px\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .aims-select-secondary-txt-wrap {\n        display: none;\n    }\n}\n\n.aims-select-text-wrap {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 4px;\n    margin-left: 4px;\n}\n\n.aims-select-primary-txt {\n    color: #1773b0;\n}\n\n.aims-select-task-btn:hover .aims-select-primary-txt {\n    color: var(--color-interactive-primary-hover);\n    text-decoration: underline;\n}\n\n.aims-select-secondary-txt {\n    color: #666666;\n}\n\n/* Ideas / New */\n.aims-ideas-col {\n    padding-right: 30px;\n    border-right: 1px solid #E2E2E2;\n}\n\n.aims-new-col {\n    padding-left: 12px;\n}\n\n.aims-ideas-new-wrap {\n    margin-bottom: 20px;\n    margin-left: 16px;\n    margin-right: 16px;\n}\n\n.aims-ideas-heading-inner {\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px;\n    /* 128.571% */\n    letter-spacing: 0.1px;\n}\n\n.aims-new-ideas-heading-more {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n@media only screen and (max-width: 500px) {\n    .aims-new-ideas-heading-more {\n        margin-bottom: 0;\n    }\n}\n\n.aims-ideas-li {\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.aims-new-ul {\n    padding-left: 20px;\n    margin-top: 10px;\n}\n\n.aims-new-ul li {\n    list-style: disc;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.aims-select-text-wrap {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 4px;\n    margin-left: 4px;\n}\n\n.aims-select-primary-txt {\n    color: #1773b0;\n}\n\n.aims-select-task-btn:hover .aims-select-primary-txt {\n    color: var(--color-interactive-primary-hover);\n    text-decoration: underline;\n}\n\n.aims-select-secondary-txt {\n    color: #666666;\n}\n\n@media only screen and (max-width: 768px) {\n    .aims-ideas-col {\n        padding-right: 0;\n        padding-bottom: 20px;\n        border-bottom: 1px solid #E2E2E2;\n        border-right: none;\n    }\n\n    .aims-new-col {\n        padding-left: 0;\n        padding-top: 20px;\n        padding-bottom: 20px;\n    }\n}\n\n@media only screen and (max-width: 500px) {\n    .aims-ideas-col {\n        padding-bottom: 0px;\n    }\n\n    .aims-new-col {\n        padding-top: 0px;\n    }\n\n    .aims-new-ideas-heading-more {\n        justify-content: flex-start;\n        gap: 8px;\n        font-size: 14px;\n    }\n\n    .ideas-new-list-wrap {\n        display: none;\n    }\n\n    .aims-ideas-col {\n        border-bottom: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
